var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "news"
  }, [_c("section", {
    staticClass: "news__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "新闻动态",
      description: "聚焦同花顺最新发展动态，为您解读同花顺的产品、技术、案例和生态，带您追踪行业发展新态式。",
      showAppoint: false
    }
  })], 1), _c("main", {
    staticClass: "news__article-wrapper"
  }, [_c("news-tab", {
    attrs: {
      tabList: _vm.tabList
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };